import { render, staticRenderFns } from "./SocialECommerce.vue?vue&type=template&id=1b722477&scoped=true&"
import script from "./SocialECommerce.vue?vue&type=script&lang=js&"
export * from "./SocialECommerce.vue?vue&type=script&lang=js&"
import style0 from "./SocialECommerce.vue?vue&type=style&index=0&id=1b722477&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b722477",
  null
  
)

export default component.exports